export default __webpack_public_path__ + "static/media/005-badge.3d264143.svg";